class FaqSearch extends HTMLElement {
  constructor () {
    super()

    this.input = this.querySelector('input[type="search"]')
    this.status = this.querySelector('.faq-search-status')
    this.empty = this.querySelector('.faq-search-empty')
    this.form = this.querySelector('form.search-form')

    this.form?.addEventListener('submit', (event) => {
      event.preventDefault()
      this.input.focus()
    })

    this.input.addEventListener('input', window.theme.debounce(() => {
      this.filter()
    }, 200))
  }

  filter () {
    const query = this.input.value.trim().toLowerCase()
    const faqSections = document.querySelectorAll('.faq-section')
    let totalMatches = 0

    faqSections.forEach(section => {
      const items = section.querySelectorAll('.accordion-item')
      let sectionMatches = 0

      items.forEach(item => {
        const title = (item.dataset.faqTitle || item.querySelector('.accordion-button')?.textContent || '').toLowerCase()
        const body = (item.dataset.faqBody || item.querySelector('.accordion-body')?.textContent || '').toLowerCase()
        const match = !query || title.includes(query) || body.includes(query)

        item.hidden = !match
        if (match) sectionMatches++
      })

      const shopifySection = section.closest('[id^="shopify-section-"]')
      if (shopifySection) {
        shopifySection.hidden = query.length > 0 && sectionMatches === 0
      }

      if (query && sectionMatches > 0) {
        const groupCollapse = section.querySelector('[id^="faq-group-collapse-"]')
        if (groupCollapse) {
          bootstrap.Collapse.getOrCreateInstance(groupCollapse).show()
        }
      }

      totalMatches += sectionMatches
    })

    if (query) {
      this.status.hidden = false
      this.status.textContent = `${totalMatches} result${totalMatches === 1 ? '' : 's'}`
      this.empty.hidden = totalMatches > 0
    } else {
      this.status.hidden = true
      this.status.textContent = ''
      this.empty.hidden = true
    }
  }
}

if (!customElements.get('faq-search')) {
  customElements.define('faq-search', FaqSearch)
}
